import { IJBPMAP } from '../../../models/IJBPPMAP'
import { EMPTY_MAP_PLACEHOLDER, PLANNING_BY_FY_FQ } from '../../config'

export const getMapValueStandard = (
  mapData: IJBPMAP[],
  fy: number,
  category: string,
  fq: number,
  isUnits: boolean = false
): string => {
  let result = EMPTY_MAP_PLACEHOLDER

  const unitStr = isUnits ? 'Unit' : ''
  let fieldName = `${unitStr}Q${fq}`
  if (fq === PLANNING_BY_FY_FQ) {
    fieldName = `${unitStr}FY`
  }

  const mapDataFiltered = mapData.filter((el) => el.FYear === fy && el.Category === category)
  if (mapDataFiltered.length >= 1) {
    result = `${mapDataFiltered[0][fieldName]}%`
  } else {
    // error in data
  }

  return result
}
